import { render } from "./AddMeldingOpslaanView.vue?vue&type=template&id=0723ae90&scoped=true"
import script from "./AddMeldingOpslaanView.vue?vue&type=script&lang=js"
export * from "./AddMeldingOpslaanView.vue?vue&type=script&lang=js"

import "./AddMeldingOpslaanView.vue?vue&type=style&index=0&id=0723ae90&scoped=true&lang=less"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0723ae90"]])

export default __exports__